// Header Looniva: altezza in --lv-hh, si nasconde scendendo e ricompare
// risalendo, mega menu al passaggio o al focus, Esc per chiudere.
(() => {
  const hd = document.querySelector('[data-lv-header]');
  if (!hd) return;
  const root = document.documentElement;
  const setH = () => root.style.setProperty('--lv-hh', `${hd.offsetHeight}px`);
  setH();
  addEventListener('resize', setH, { passive: true });

  let last = scrollY;
  addEventListener('scroll', () => {
    const y = scrollY;
    const down = y > last && y > hd.offsetHeight * 2;
    hd.classList.toggle('is-up', down && !hd.classList.contains('is-open') && !root.classList.contains('lv-mm-open'));
    last = y;
  }, { passive: true });

  const mega = hd.querySelector('[data-lv-mega]');
  if (!mega) return;
  let t;
  const open = () => { clearTimeout(t); hd.classList.add('is-open'); };
  const close = () => { t = setTimeout(() => hd.classList.remove('is-open'), 120); };
  hd.querySelectorAll('[data-lv-mega-trigger]').forEach((a) => {
    a.addEventListener('mouseenter', open);
    a.addEventListener('focus', open);
  });
  hd.addEventListener('mouseleave', close);
  mega.addEventListener('mouseenter', open);
  hd.addEventListener('focusout', (e) => { if (!hd.contains(e.relatedTarget)) close(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') hd.classList.remove('is-open'); });
})();

// Menu mobile: apre e chiude, blocca lo scroll, Esc chiude, focus dentro.
(() => {
  const btn = document.querySelector('[data-lv-burger]');
  const mm = document.getElementById('lv-mm');
  if (!btn || !mm) return;
  const root = document.documentElement;
  const close = () => {
    mm.classList.remove('is-open');
    root.classList.remove('lv-mm-open');
    root.style.overflow = '';
    btn.setAttribute('aria-expanded', 'false');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(() => { mm.hidden = true; btn.focus(); }, reduced ? 0 : 500);
  };
  const open = () => {
    mm.hidden = false;
    requestAnimationFrame(() => mm.classList.add('is-open'));
    root.classList.add('lv-mm-open');
    root.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
    mm.querySelector('a, button')?.focus();
  };
  btn.addEventListener('click', () => (mm.hidden ? open() : close()));
  mm.querySelector('[data-lv-mm-close]')?.addEventListener('click', close);
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && !mm.hidden) close(); });
  mm.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = [...mm.querySelectorAll('a, button, summary')];
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
    else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
  });
})();
